import { ProfileHeader } from "@components/profile-header";
import { TextWithTooltip } from "@components/common/text-with-tooltip";
import { getMemberDisplayName } from "@utils/data-display";
import { BaseMemberProps } from "@custom-types/base-types";
import { grey } from "@flat-ui";

/**
 * Display member information in the header of member profile page
 */
export function MemberProfileHeader({
  member,
}: BaseMemberProps): React.JSX.Element {
  return (
    <ProfileHeader
      type="USER"
      name={getMemberDisplayName(member)}
      subheaderElement={
        <TextWithTooltip
          text={member.email}
          lines={2}
          customSx={{ color: grey[400] }}
        />
      }
    />
  );
}
